import { render, staticRenderFns } from "./CompoundDataTable.vue?vue&type=template&id=52a0bced&"
import script from "./CompoundDataTable.vue?vue&type=script&lang=js&"
export * from "./CompoundDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports